import React from 'react';
import { FaPrint, FaFileExport, FaDownload, FaFilter, FaSyncAlt } from 'react-icons/fa';

interface ExportControlsProps {
  onPrint: () => void;
  onExportPDF: () => void;
  onExportCSV: () => void;
  onToggleFilters: () => void;
  onRefresh: () => void;
  showFilters: boolean;
}

const ExportControls: React.FC<ExportControlsProps> = ({
  onPrint,
  onExportPDF,
  onExportCSV,
  onToggleFilters,
  onRefresh,
  showFilters
}) => {
  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onPrint}
        className="flex items-center gap-2 text-xs px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors bg-white"
        title="Print Dashboard"
      >
        <FaPrint className="h-4 w-4" />
        <span className="hidden sm:inline">Print</span>
      </button>
      <button
        onClick={onExportPDF}
        className="flex items-center gap-2 text-xs px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors bg-white"
        title="Export as PDF"
      >
        <FaFileExport className="h-4 w-4" />
        <span className="hidden sm:inline">PDF</span>
      </button>
      <button
        onClick={onExportCSV}
        className="flex items-center gap-2 text-xs px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors bg-white"
        title="Export as CSV"
      >
        <FaDownload className="h-4 w-4" />
        <span className="hidden sm:inline">CSV</span>
      </button>

      <button
        onClick={onRefresh}
        className="flex items-center gap-2 text-xs px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors bg-white"
      >
        <FaSyncAlt className="h-4 w-4" />
        Refresh
      </button>
    </div>
  );
};

export default ExportControls;